import { z } from 'zod';
import type { ApiKeyCreateRequest, ApiKeyUpdateRequest } from '@sleed/bizcommerce-api';

/** API key create/edit form — name required, optional description, scoped endpoint ids. */
export const apiKeySchema = z.object({
	id: z.number().optional(),
	name: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	description: z.string().trim().max(255, 'validation.tooLong').nullable(),
	endpointIds: z.array(z.string())
});

export type ApiKeyFormValues = z.infer<typeof apiKeySchema>;

export const EMPTY_API_KEY: ApiKeyFormValues = { name: '', description: null, endpointIds: [] };

export function formToCreateRequest(form: ApiKeyFormValues): ApiKeyCreateRequest {
	return { name: form.name.trim(), description: form.description?.trim() || null, endpointIds: form.endpointIds };
}

export function formToUpdateRequest(form: ApiKeyFormValues): ApiKeyUpdateRequest {
	return { name: form.name.trim(), description: form.description?.trim() || null, endpointIds: form.endpointIds };
}
